import { createAction } from '@reduxjs/toolkit';

import { globalLiveUpdatesSubPath, StorageKeys } from '../../constants/storageKeys';
import { setIntoLocalStorage } from '../../internals/local-storage';

import type { AppThunk } from '../../types/state.types';

export type CommandPaletteType = 'datahubObjects';

export const layoutChanged = createAction('global/layoutChanged');
export const commandPaletteToggled = createAction<CommandPaletteType | undefined>(
  'global/commandPaletteToggled'
);

export const portalJwtUpdated = createAction<string>('global/portalJwtUpdated');

export type ToastType = 'success' | 'notification' | 'warning';
export type Toast = {
  type: ToastType;
  message: string;
};
function prepareToast(config: Toast) {
  const { type, message } = config;
  return {
    payload: {
      message,
      type,
    },
  };
}

export const toastAdded = createAction<typeof prepareToast>('toast/added', prepareToast);
export const toastDismissed = createAction('toast/dismissed');

export const darkModeActivated = createAction('theme/darkModeActivated');

export const darkModeDeactivated = createAction('theme/darkModeDeactivated');

export type ComponentType = 'pipes' | 'systems' | 'datasets';

export const showZendeskWindow = createAction('zendesk/showWindow');
export const hideZendeskWindow = createAction('zendesk/hideWindow');

export const enableLiveUpdates = createAction('globals/enableLiveUpdates');

export const disableLiveUpdates = createAction('globals/disableLiveUpdates');

export const GlobalActions = {
  enableLiveUpdatesGlobally(subscriptionId: string): AppThunk {
    return (dispatch, getState) => {
      dispatch(enableLiveUpdates());

      if (getState().globals.enableLiveUpdates === true) {
        setIntoLocalStorage(StorageKeys.liveUpdates, globalLiveUpdatesSubPath, true);
      }
    };
  },
  disableLiveUpdatesGlobally(subscriptionId: string): AppThunk {
    return (dispatch, getState) => {
      dispatch(disableLiveUpdates());

      if (getState().globals.enableLiveUpdates === false) {
        setIntoLocalStorage(StorageKeys.liveUpdates, globalLiveUpdatesSubPath, false);
      }
    };
  },
};
